export default 'M12.33 0a4 4 0 0 0-4 4v6.52a7.33 7.33 0 1 0 8 0V4a4 4 0 0 0-4-4M9.88 12.9l1.29-.85V6.17h2.33v5.88l1.29.84a4.5 4.5 0 1 1-4.9 0';